import React, { Component, createRef, useMemo } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import TransparentOverlay from "../form-section/TransparentOverlay";
import { buttonStyle, formSubmissionErrorStyle } from "./styles";
import AgentLocatorPage from "../agent/AgentLocatorPage";
import AgentFormPage from "../agent/AgentFormPage";
import { sendBookingThroughAgent } from "../../GraphQL/entities";

import {
  Form,
  Icon,
  Row,
  Col,
  Button,
  Typography,
  Result
} from "antd";
import ShipperBasicForm from "./ShipperBasicForm";

const { Title } = Typography;


const errorDivRef = React.createRef();

class BookViaAgent extends React.Component {
  state = {
    country: "",
    phoneNumber: "",
    bookingData: {},
    token: {},
    isFormSubmissionError: false,
    currentStep: 1,
    showCustomBrokerInput: false,
    shipperReceiverForm1: {
      email: "",
      customer_first_name: "",
      customer_last_name: "",
      phone: "",
      company_name: "",
      street: "",
      address: "",
      city: "",
      state: "",
      postal: "",
      country: "",
    },
    resultBookingId: "",
    selectedAgent: null,
    finalForm: {
        message: "",
        captcha: "",
    },
  };

  fetchAgents = async () => {
    try {
      const { queryParams, final_search_form } =
        this.props;
      const response = await this.props.getAllAgentProfiles(false);
      const agentProfiles = response && response[1];
      const countryId = queryParams?.from?.countryId;
      
      const mode = final_search_form?.selected_card_json?.mode;

      if (agentProfiles && countryId && agentProfiles.length > 0) {
        const agentInfo = agentProfiles.filter((record) => {
          // Check if the country ID matches
          const matchesCountryId = record.countryEntity.id === countryId;

          // Check if the mode matches and the respective flag is true
          const matchesMode =
            (mode === "Sea" && record.isSea) ||
            (mode === "Air" && record.isAir);

          return matchesCountryId && matchesMode;
        });
        this.setState({ selectedAgent: agentInfo?.[0] });
      } else {
        console.log("Agent profiles not found");
        //this.setState({selectedAgent: agentInformation});
      }
    } catch (error) {
      console.error("Error fetching brokers:", error);
      //this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.fetchAgents();
  }

  handleSendToShipper = (agent) => {
    this.setState((prevState) => {
      // Update state and return new state
      return {
        currentStep: prevState.currentStep + 1,
        selectedAgent: agent,
      };
    });
  };

  handleNextSubmit = (e) => {
    e.preventDefault();
    if (this.state.currentStep === 1) {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          // increment the step
          this.setState((prevState) => ({
            currentStep: prevState.currentStep + 1,
          }));
          this.setState({
            isFormSubmissionError: false,
          });
        } else {
          this.setState({ isFormSubmissionError: true });
          if (errorDivRef.current) {
            errorDivRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    } else if (this.state.currentStep === 2) {
      // Handle form submission for step 2
      this.props.form.validateFields(async (err, values) => {
        if (!err) {
          this.setState((prevState) => ({
            currentStep: prevState.currentStep + 1,
          }));
          this.setState({
            isFormSubmissionError: false,
            shipperReceiverForm1: values,
          });
        }
        else {
          this.setState({ isFormSubmissionError: true });
          if (errorDivRef.current) {
            errorDivRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    } else if (this.state.currentStep === 3) {
      this.props.form.validateFields(async (err, values) => {
        // console.log("----------Received values of final form: ", values);
        if (!err) {
            this.setState({ isFormSubmissionError: false, finalForm: values });
            this.setState({ showOverlay: true });
            try {
              const response = await sendBookingThroughAgent(
                this.props.jwt_token,
                this.props.booking_customer_form,
                this.state.shipperReceiverForm1,
                values,
                this.state.selectedAgent
              );
            //const response = true;
              if (response) {
                this.setState({
                  currentStep: this.state.currentStep + 1,
                  showOverlay: false,
                }, () =>{
                    if (errorDivRef.current) {
                        errorDivRef.current.scrollIntoView({ behavior: "smooth" });
                    }
                });
              } else {
                this.setState({ showOverlay: false });
                this.props.updateErrorAndLoading(
                  "Please try again or contact Prime Freight",
                  undefined
                );
              }
            } catch (err) {
              console.log(err);
            }
          } else {
            this.setState({ isFormSubmissionError: true });
            if (errorDivRef.current) {
              errorDivRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }
        });    
    }
  };

  handlePrevious = () => {
    const { currentStep } = this.state;
    // Go back to the previous step if currentStep is greater than 1
    if (currentStep > 1) {
      this.setState({ currentStep: currentStep - 1 });
    }
  };

  handleGoBack = () => {
    this.setState({ currentStep: 1 });
    this.setState({ shipperReceiverForm1: "", finalForm: "" });
  };

  render() {
    return (
      <div
        ref={errorDivRef} //style={{padding: '2rem 0'}}
      >
        <Row
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: "1rem",
          }}
        >
          {/* <div >
          <Button
            type="link"
            style={{ marginRight: '10px' }}
            onClick={this.handlePrevious}
            disabled={this.state.currentStep === 1}
          >
            <Icon type="left" />
            Previous
          </Button>
          <Button
            type="link"
            htmlType="submit"
            onClick={this.handleNextSubmit}
            disabled={this.state.currentStep === 3}
          >
            Next
            <Icon type="right" />
          </Button>
      
        </div> */}
        </Row>
        <Row
          type="flex"
          justify="center" //style={{border:"1px solid red"}}
        >
          <Col xs={20} sm={20} md={16} lg={12}>
            {this.state.isFormSubmissionError ? (
              <div style={formSubmissionErrorStyle}>
                <Icon
                  type="exclamation-circle"
                  style={{ fontSize: "20px", color: "#790000" }}
                  theme="outlined"
                />
                &nbsp;
                <span>
                  There was a problem with your submission. Please review the
                  fields below.
                </span>
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>

        <Form //{...formItemLayout}
          onSubmit={this.handleSubmit}
          className="booking-form" //style={bookingForm}
        >
          {/* Section 1 */}
          {this.state.currentStep === 1 && (
            <div>
              <AgentLocatorPage onSendShipper={this.handleSendToShipper} />
            </div>
          )}

          {/* Section 2 */}
          {this.state.currentStep === 2 && (
            <Row
              type="flex"
              justify="center" //style={{border:"1px solid red"}}
            >
              <Col xs={20} sm={20} md={16} lg={12}>
                <div>
                  <div style={{ paddingBottom: "1rem" }}>
                    {this.props.booking_customer_form.customer_type?.includes(
                      "Importer"
                    ) ? (
                      <div>
                        <Title level={2}>Your Shipper</Title>
                        <p
                          style={{
                            paddingBottom: "1rem",
                            borderBottom: "2px solid black",
                          }}
                        >
                          Who is shipping this cargo
                        </p>
                        <p style={{ paddingTop: "1rem" }}>
                          We will need some information about your shipper.
                          {/* Your shipper will be contacted by Prime Freight or our agent in the region of departure. */}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <Title level={2}>Your Receiver</Title>
                        <p
                          style={{
                            paddingBottom: "1rem",
                            borderBottom: "2px solid black",
                          }}
                        >
                          We will need some information about your receiver. The
                          receiver will be contacted by Prime Freight.
                        </p>
                      </div>
                    )}
                  </div>
                  <ShipperBasicForm
                    {...{ form: this.props.form }}
                    initialFormData={this.state.shipperReceiverForm1}
                  />
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={buttonStyle}
                      onClick={this.handleNextSubmit}
                    >
                      Next
                    </Button>
                  </Form.Item>
                </div>
              </Col>
            </Row>
          )}
          {this.state.currentStep === 3 && (
              <div>
                <Row
                  type="flex"
                  justify="center"
                >
                  <Col xs={20} sm={20} md={16} lg={12}>
                    <AgentFormPage
                      {...{ form: this.props.form }}
                      finalForm={this.state.finalForm}
                      selectedAgent={this.state.selectedAgent}
                      customerInfo={this.props.booking_customer_form}
                      shipperInfo={this.state.shipperReceiverForm1}
                    />
                    <Form.Item>
                      <Button
                        type="default"
                        style={buttonStyle}
                        onClick={this.handlePrevious}
                      >
                        Previous
                      </Button>
                      <Button
                        type="default"
                        htmlType="submit"
                        style={buttonStyle}
                        onClick={this.handleNextSubmit}
                      >
                        Send
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
                {this.state.showOverlay && (
                  <TransparentOverlay message="Please wait..." />
                )}
              </div>
            )}

            {this.state.currentStep === 4 && (
              <div style={{ backgroundColor: "#FFF" }}>
                <Result
                  status="success"
                  title={`Information sent Successfully`}
                  subTitle="The email has been sent to both the Agent and your Shipper/Receiver. The Agent will be in touch with you shortly!"
                  extra={
                    <Button
                      index = {0}
                      type="default"
                      style={{ ...buttonStyle, width: "200px" }}
                      onClick={this.handleGoBack}
                    >
                      Back to Agents
                    </Button>
                  }
                />
              </div>
            )}
        </Form>
      </div>
    );
  }
}

const WrappedBookViaAgentForm = Form.create({ name: "book_via_agent" })(
  BookViaAgent
);

BookViaAgent.propTypes = {
  /**
   * array index (starts from zero) of selected pickup/delivery existing factory in the list of factories.
   * It also accepts `null`
   */
  final_search_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    booking_customer_form: state.route.booking_customer_form,
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
    agentInformation: state.form.AgentInformation,
    saveDataShowOverlay: state.code_config.saveDataShowOverlay,
    transactionType: state.code_config.transactionType,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedBookViaAgentForm)
);
